import axios from 'axios';
import { BRAND_BASE_URL, STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const CustomerOrderPackageLog = data => {
  return axios({
    method: 'post',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v1/customer-order-package-log', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const CartPackageCarryForwardApply = (storeId, storeCustomerId, data) => {
    return axios({
      method: 'put',
      url:
        BRAND_BASE_URL +
        '/store/api/secure/store/' + storeId + '/store-customer/' + storeCustomerId + '/cart-package-carry-forward-apply', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const markCarryForward = (storeCustomerId, storeId, data) => {
    return axios({
      method: 'put',
      url:
        BRAND_BASE_URL +
        '/store/api/secure/store/' + storeId + '/store-customer/' + storeCustomerId + '/cart-package-carry-forward', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const OrderPackageCarryForwardUpdate = (brandId, data) => {
    return axios({
      method: "post",
      url:
        BRAND_BASE_URL +
        "/store/api/secure/v1/brand/" +
        brandId +
        "/order-package-carry-forward",
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

export const RemoveSubscriptionBalance = (brandId, storeCustomerId) => {
  return axios({
    method: "get",
    url:
      BRAND_BASE_URL +
      "/consumer/api/secure/v1/store/" +
      brandId +
      "/store-customer/" + storeCustomerId + 
      "/remove-subscription-balance",
    headers: getHeaders(),
  });
};